import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=4ffc5f66"
import script from "./SearchFilters.vue?vue&type=script&lang=ts"
export * from "./SearchFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports